export default __webpack_public_path__ + "static/media/mail.f78aaf49.png";